export const FOOTER_CONTENT = [
  {
    label: 'Facebook',
    url: 'http://www.facebook.com/ship.UPDS'
  }, {
    label: 'LinkedIn',
    url: 'https://www.linkedin.com/company/union-pacific-distribution-services'
  }, {
    label: 'Twitter',
    url: 'https://twitter.com/ShipUPDS?lang=en'
  }, {
    label: 'Instagram',
    url: 'https://www.instagram.com/shipupds/'
  }, {
    label: 'Careers',
    url: 'https://up.jobs/search-jobs.html?deptIds=210000'
  }, {
    label: 'Security',
    url: '/security.html'
  }, {
    label: 'Privacy',
    url: '/privacy.html'
  }
];



// WEBPACK FOOTER //
// ./src/app/shared/constants/footer-content.js